var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('navbar-landing'),_c('div',{staticClass:"app-wrapper"},[_c('child')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }